export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">爆料投稿</h2>
          <p className="text-foreground-600 leading-relaxed mb-10 max-w-xl mx-auto">
            您有独家内幕、一手证据或热点线索？欢迎通过以下方式联系我们，我们严格保护爆料人隐私信息。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
            <div className="bg-background-50 rounded-xl p-6 border border-secondary-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-primary-100 rounded-xl flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">邮件投稿</h3>
              <p className="text-sm text-foreground-500 break-all">tips@heiliao-baoliao.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-secondary-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-accent-100 rounded-xl flex items-center justify-center">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">微信投稿</h3>
              <p className="text-sm text-foreground-500">添加客服：HLBL_tougao</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-secondary-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-secondary-100 rounded-xl flex items-center justify-center">
                <i className="ri-shield-user-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">匿名提交</h3>
              <p className="text-sm text-foreground-500">支持完全匿名提交，不留痕迹</p>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-secondary-200/70 text-left max-w-lg mx-auto">
            <h3 className="text-base font-semibold text-foreground-900 mb-4 font-heading text-center">投稿须知</h3>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                <span>请提供尽可能详实的证据材料，包括但不限于截图、录音、文件等</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                <span>我们承诺对爆料人身份信息永久保密，绝不向第三方透露</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                <span>优质独家爆料一经采用，将按照内容质量给予相应稿酬奖励</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}